import styled from 'styled-components';
import { themes } from 'kb-shared';

export const ScreenWrapper = styled.div`
  @media screen and (min-width: ${themes.breakpoints.phone}) {
    padding: 80px 20px 20px 20px;
  }

  @media screen and (min-width: ${themes.breakpoints.smallDesktop}) {
    padding: 20px;
  }
`;

export const Columns = styled.div`
  ${({ theme }) => theme.fonts.FoundersGrotesk};
  display: grid;
  background-color: ${({ theme }) => theme.colors.KBNight};
  color: white;

  @media screen and (min-width: ${themes.breakpoints.phone}) {
    grid-template-columns: 1fr;
    grid-template-row: repeat(1fr, 3);
  }

  @media screen and (min-width: ${themes.breakpoints.smallDesktop}) {
    grid-template-columns: 50% 35% 15%;
    grid-template-row: 1fr;
  }
`;

export const Column = styled.div`
  padding: 10px 18px;
  display: flex;
  flex-direction: column;
  justify-content: center;

  &:first-child {
    padding: 4px 18px 18px;
  }

  &:last-child {
    border: 0;
  }

  a {
    color: ${({ theme }) => theme.colors.KBYellow};
    font-size: 18px;
    text-decoration: underline;
  }

  a:after {
    content: '\\2192';
    display: inline-block;
    margin: 0 0 0 4px;
  }

  @media screen and (min-width: ${themes.breakpoints.phone}) {
    border-bottom: 2px solid ${themes.colors.KBTwilightDark};
    padding: 22px 18px;
  }

  @media screen and (min-width: ${themes.breakpoints.smallDesktop}) {
    border-right: 2px solid ${themes.colors.KBTwilightDark};
    padding: 10px 18px;
  }
`;

export const MainHeading = styled.h2`
  ${({ theme }) => theme.fonts.DomaineDisplay};
  margin-bottom: 6px;
  font-size: 28px;
  color: ${({ theme }) => theme.colors.KBYellow};
`;

export const SubHeading = styled.h3`
  ${({ theme }) => theme.fonts.DomaineDisplay};
  font-size: 24px;
  color: ${({ theme }) => theme.colors.KBWhite};
`;

export const Description = styled.div`
  font-size: 14px;
  line-height: 18px;

  a {
    display: block;
    font-size: 14px;
    line-height: 18px;
  }
`;

export const Divider = styled.hr`
  margin: 18px 0 16px;
  border: 0;
  box-shadow: 0 1px 0 0 ${themes.colors.white};
  height: 1px;
`;

export const Form = styled.form`
  display: grid;

  .input-help {
    margin-top: 10px;
    font-size: 12px;
  }

  @media screen and (min-width: ${themes.breakpoints.phone}) {
    grid-template-columns: repeat(3, 1fr);
    grid-template-rows: repeat(2, 1fr);
    grid-template-areas:
      'label label label'
      'input input button';
    column-gap: 18px;
    row-gap: 12px;
  }

  @media screen and (min-width: ${themes.breakpoints.smallDesktop}) {
    grid-template-columns: auto auto auto auto minmax(150px, 100%) auto;
    grid-template-rows: repeat(1, 1fr);
    grid-template-areas: 'label label label label input button';
    column-gap: 8px;
    row-gap: 0;
    align-items: center;
  }
`;

export const Label = styled.label`
  ${({ theme }) => theme.fonts.DomaineDisplay};
  font-size: 18px;
  line-height: 24px;
  grid-area: label;
`;

export const Input = styled.input`
  border: 0;
  padding: 2px;
  width: 100%;
  grid-area: input;
  height: 27px;
  width: 100%;

  &:focus {
    border: 0;
  }
`;

export const ActivateButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 3px 14px;
  height: 27px;
  border-radius: 20px;
  background-color: transparent;
  border: 1px solid ${({ theme }) => theme.colors.KBWhite};
  color: ${({ theme }) => theme.colors.KBWhite};
  font-size: 18px;
  line-height: 100%;
  grid-area: button;

  &:disabled {
    cursor: not-allowed;
    color: ${({ theme }) => theme.colors.disabledGray};
    border-color: ${({ theme }) => theme.colors.disabledGray};
  }
`;
